// import external dependencies
/* global jQuery */

import Cookie from 'js-cookie';



// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import woocommerceAccount from './routes/woocommerceAccount'
// import checkout from './routes/checkout';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common, 
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  woocommerceAccount,
  // checkout,
});

// axios.defaults.withCredentials = true;

// if(window._D.nonce)
//   axios.defaults.headers.common['X-WP-Nonce'] = window._D.nonce; 


// Load Events
jQuery(document).ready(() => routes.loadEvents());

/**
 * Mobile navigation menu
 */

window.toggleSidebarMenu = function() {
  jQuery('aside.sidenav-menu').toggleClass('in');
} 

window.closeSidebarMenu = function() {
  jQuery('aside.sidenav-menu').removeClass('in');
}

window.getLastSearchURL = function() {

  var path = Cookie.get('last-search-url');

  if(path) {
    Cookie.remove('last-search-url');
  }

  return path;

}

window.setFullPageLoader = function (state, title, msg) {
  if(state) {
    jQuery('.loader-full-page').addClass('in');
    jQuery('.loader-full-page-title').html(title);
    jQuery('.loader-full-page-msg').html(msg);
  } else {
    jQuery('.loader-full-page').removeClass('in');
  }
}

window.toggleSearchPane = function() {
  jQuery('aside.mobile-search-pane').toggleClass('in');
} 

window.closeSearchPane = function() {
  jQuery('aside.mobile-search-pane').removeClass('in');
}

jQuery(document).ready(() => {

  /**
   * Blog Search
   */

  jQuery('.search-input-hitzone').on('click', function(){
      jQuery('.blog-search form').submit();
  });


 
/**
 * Mobile Search Pane
 */


 jQuery('.mobile-search-trigger').on('click', function(e){
   e.preventDefault();
   jQuery('.mobile-search-pane .search-form-input').focus();

   jQuery('aside.mobile-search-pane').addClass('in');

 });

 /**
  * Desktop Search Box
  */

 jQuery('.large-search .search-form-input, .mobile-search-pane .search-form-input').keypress(function(event) {
  var keycode = event.keyCode || event.which;
  if(keycode == '13') {
    window.location = '/buy-wine/' + encodeURIComponent(jQuery(this).val().replace('%', ''));

  }
});

  jQuery('.large-search-trigger').on('click', function(e){
    jQuery('.large-search .search-form-input').focus();
    e.preventDefault();
    jQuery('.mega-menu-pane').removeClass('in');
    jQuery('.large-main-menu > ul > li').removeClass('active');
    if(jQuery('.page-header').hasClass('search-in')) {

      if(jQuery('.large-search .search-form-input').val().length > 0) {
        window.location = '/buy-wine/' + encodeURIComponent(jQuery('.large-search .search-form-input').val().replace('%', ''));
      } else {
        jQuery('.page-header').removeClass('search-in');
      }

    } else {
      jQuery('.page-header').addClass('search-in');
    }
    
  });

  /**
   * Desktop Mega Menu
   */

   jQuery('[data-toggle=mega]').each(function() {
     jQuery(this).on('click', function(e){
       e.preventDefault();
       jQuery('.mega-menu-pane').not('[aria-labelledby=' + jQuery(this).attr('id') + ']').removeClass('in');
       jQuery('.mega-menu-pane[aria-labelledby=' + jQuery(this).attr('id') + ']').toggleClass('in');
       jQuery('.large-main-menu > ul > li > .nav-link').not(this).parent('li').removeClass('active');
       jQuery(this).parent('li').toggleClass('active');
     });
   });

  jQuery(window).click(function() {
    jQuery('.mega-menu-pane').removeClass('in');
    jQuery('.large-main-menu > ul > li').removeClass('active');
    jQuery('.page-header').removeClass('search-in');
    });
    
  jQuery('.mega-menu-pane, .nav-link, .search-form-input, .large-search-trigger').click(function(event){
        event.stopPropagation();
    });

  jQuery('.large-main-menu > ul > .current-menu-parent, .large-main-menu > ul > .current-menu-item').slice(1).removeClass('current-menu-parent').removeClass('current-menu-item');

});


// WEBPACK FOOTER //
// ./scripts/main.js